import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import RbFooter from "./components/RbFooter";
import MarqueeBottom from "./components/MarqueeBottom";
import WhatsAppButton from "./components/WhatsAppButton";
import Banner from "./components/Banner";
import { useSupportContacts, whatsappUrl } from "../utils/useSupportContacts";

/* The page used to carry another brand's template: a "Customer Support"
   tile with no link, and email, Telegram, Facebook, YouTube and Instagram
   addresses that all belonged to Kheloyaar. It now shows only our own
   channels, read from Admin -> Accounts, so there is one place to change
   them. */
const telegramHandle = (url) => {
  const m = String(url || "").match(/t\.me\/([^/?#]+)/i);
  return m ? `@${m[1]}` : "Open Telegram";
};

const formatPhone = (digits) => (digits ? `+${digits}` : "");

const ContactPanel = () => {
  const contacts = useSupportContacts();
  const wa = whatsappUrl(contacts?.whatsapp);
  const tg = contacts?.telegram || "";

  return (
    <section className="rb-contact" aria-labelledby="rb-contact-title">
      <h1 id="rb-contact-title" className="rb-contact__title">
        Contact support
      </h1>
      <p className="rb-contact__lead">
        Questions about a bet, a deposit, a withdrawal or your account? Our
        team is available 24/7.
      </p>

      {contacts === null ? (
        <p className="rb-contact__muted">Loading support contacts…</p>
      ) : wa || tg ? (
        <div className="rb-contact__grid">
          {wa && (
            <a
              className="rb-contact__card rb-contact__card--wa"
              href={wa}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="rb-contact__icon rb-contact__icon--wa" aria-hidden="true">
                <img src="/assets/images/whatsappImages.svg" alt="" width="22" height="22" />
              </span>
              <span>
                <span className="rb-contact__name">WhatsApp</span>
                <span className="rb-contact__value">{formatPhone(contacts.whatsapp)}</span>
              </span>
              <i className="fa fa-chevron-right rb-contact__go" aria-hidden="true" />
            </a>
          )}
          {tg && (
            <a
              className="rb-contact__card rb-contact__card--tg"
              href={tg}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="rb-contact__icon rb-contact__icon--tg" aria-hidden="true">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="#fff">
                  <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71l-4.13-3.05-1.99 1.93c-.23.23-.42.42-.83.42z" />
                </svg>
              </span>
              <span>
                <span className="rb-contact__name">Telegram</span>
                <span className="rb-contact__value">{telegramHandle(tg)}</span>
              </span>
              <i className="fa fa-chevron-right rb-contact__go" aria-hidden="true" />
            </a>
          )}
        </div>
      ) : (
        <p className="rb-contact__muted">
          Support contacts are being updated. Please check back shortly.
        </p>
      )}

      <p className="rb-contact__note">
        Never share your password or OTP with anyone, including our support
        team.
      </p>
    </section>
  );
};

const ContactUs = () => {
  const [isSidebar, setSidebar] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      // Start closed and let the visitor open it. Forcing it open
      // above 991px put a fixed panel over the page content.
      setSidebar(false);
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <ContactPanel />
                <RbFooter />
                <MarqueeBottom onMenuClick={() => setSidebar(true)} />
                <WhatsAppButton />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default ContactUs;
